import { downloadFile } from "@/store/services/offerService";
import { EmailMessage, MESSAGE_TEMPLATES } from "@/types";
import { sendMail, sendMailICS } from "../task/contactMechanism";
import moment from "moment";


export async function sendMailWithDocument(emailSendList: string[], attachment: any, fileReferences?: any, templateParameters?: Record<string, any>) {
    const attachments:any = []
    
    if (fileReferences) {
      for (const ref of fileReferences){
        if(ref){
            const file = await downloadFile(ref)
            file 
            ? attachments.push(
                    {
                        objectType: "odm.contactmechanism.emailattachment",
                        systemUid: "odm-contactmechanism",
                        resourceUid: null,
                        attachment: {
                        objectType: "contactmechanism-emailattachment",
                            systemUid: "odm-contactmechanism",
                            resourceUid: "signatory-checking", //res.document.resourceUid,
                        },
                        label: file.originalFileName,
                        originalFileName: file.originalFileName,
                        format: file.format,
                        content: file.content
                    }
            )
            :null
        }
      }
    }
      

    attachment 
    ? attachments.push(
            {
                objectType: "odm.contactmechanism.emailattachment",
                systemUid: "odm-contactmechanism",
                resourceUid: "signatory-checking",
                attachment: {
                objectType: "contactmechanism-emailattachment",
                    systemUid: "odm-contactmechanism",
                    resourceUid: "signatory-checking", 
                },
                label: attachment.label,
                originalFileName: attachment.originalFileName,
                format: attachment.format,
                content: attachment.content
            }
    )
    :null

    const parameters: Record<string, any> = {
        signatory_name: emailSendList.join(),
        signatory_email: emailSendList.join().replace(",", ";"),
    };
    if (templateParameters && typeof templateParameters === "object") {
        Object.assign(parameters, templateParameters);
    }

    const body: EmailMessage = {
        objectType: "odm.contactmechanism.communicationrequest.emailmessage",
        clientApplication: {
          systemUid: "odm-contactmechanism",
          objectType: "odm.contactmechanism.contactmechanismclient",
          resourceUid: "ApplicationClient",
        },
        emailTemplate: {
          objectType: "odm.contactmechanism.emailtemplate",
          systemUid: "odm-contactmechanism",
          resourceUid: templateParameters && typeof templateParameters === "object" ? MESSAGE_TEMPLATES.SEND_EMAIL_TEMPLATE : "SendNoticeTemplate",
        },
        parameters,
        businessData: null,
        relatedObjects: null,
        attachments
    };

    await sendMail(body)

}

export async function sendMailICSWithDocument(emailSendList: string[], attachment: any, fileReferences?: any, event?:any) {
  const attachments:any = []
  
  if (fileReferences) {
    for (const ref of fileReferences){
      if(ref){
          const file = await downloadFile(ref)
          file 
          ? attachments.push(
                  {
                      objectType: "odm.contactmechanism.emailattachment",
                      systemUid: "odm-contactmechanism",
                      resourceUid: null,
                      attachment: {
                      objectType: "contactmechanism-emailattachment",
                          systemUid: "odm-contactmechanism",
                          resourceUid: "signatory-checking", //res.document.resourceUid,
                      },
                      label: file.originalFileName,
                      originalFileName: file.originalFileName,
                      format: file.format,
                      content: file.content
                  }
          )
          :null
      }
    }
  }
    

  attachment 
  ? attachments.push(
          {
              objectType: "odm.contactmechanism.emailattachment",
              systemUid: "odm-contactmechanism",
              resourceUid: "signatory-checking",
              attachment: {
              objectType: "contactmechanism-emailattachment",
                  systemUid: "odm-contactmechanism",
                  resourceUid: "signatory-checking", 
              },
              label: attachment.label,
              originalFileName: attachment.originalFileName,
              format: attachment.format,
              content: attachment.content
          }
  )
  :null

  const body: EmailMessage = {
      objectType: "odm.contactmechanism.communicationrequest.emailmessage",
      clientApplication: {
        systemUid: "odm-contactmechanism",
        objectType: "odm.contactmechanism.contactmechanismclient",
        resourceUid: "ApplicationClient",
      },
      emailTemplate: {
        objectType: "odm.contactmechanism.emailtemplate",
        systemUid: "odm-contactmechanism",
        resourceUid: "SendNoticeTemplate",
      },
      parameters: {
        signatory_name: emailSendList.join(),
        eventUid: event.id,
        organizerEmail: emailSendList.join().replace(",", ";"),
        attendeeEmail: emailSendList.join().replace(",", ";"),
        summary: event.category,
        description: event.content,
        location: "attelier",
        startDate: moment(event.start, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(event.end, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        signatory_email: emailSendList.join().replace(",", ";"),
      },
      businessData: null,
      relatedObjects: null,
      attachments
  };

  await sendMailICS(body)
  
}
